module.exports = __webpack_public_path__ + "img/regSupp-3.de27d38d.jpg";